import { serverURL } from '../config';

const unifiedLogin = async (req, sender) => {
   const { orgID, did, email } = req.payload;
  if (!email || email === '') {
    return {
      ok: false,
      reason: 'Please enter a valid email',
    };
  }

  const authRequestRes = await fetch(serverURL + '/api/auth/login', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${did}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ orgID, email }),
  });

  if (!authRequestRes.ok) {
    return {
      ok: false,
      status: authRequestRes.status,
    };
  }

  const authRequestData = await authRequestRes.json();

  return {
    ok: authRequestRes.ok,
    status: authRequestRes.status,
    data: authRequestData,
  };
};

const checkOrgExists = async (req, sender) => {
  const {email} = req.payload;

  const checkOrgExistsRes = await fetch(serverURL + '/api/auth/checkOrg', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });
  if (!checkOrgExistsRes.ok) {
    return {
      ok: false,
      reason: "We're sorry, an error occurred",
    };
  }
  const checkOrgExistsData = await checkOrgExistsRes.json();
  
  return {
    ok: checkOrgExistsRes.ok,
    exists: checkOrgExistsData.exists,
  };
};


export { unifiedLogin, checkOrgExists };
